<template>
  <div class="mx-auto w-full max-w-sm">
    <div>
      <img class="h-16 w-auto" src="../../assets/logo.svg" alt="logo"/>
      <h2 class="mt-6 text-3xl leading-9 font-bold text-gray-900">
        Войдите в свой аккаунт
      </h2>
      <p class="mt-2 text-sm leading-5 text-gray-600 max-w">
        Или
        <router-link to="/create" class="link">зарегистрируйтесь как координатор</router-link>
      </p>
    </div>

    <div class="mt-8">
      <div class="mt-6">
        <ui-form @submit.prevent.stop="tryLogin">
          <ui-form-item error-text="text" required label="Электронная почта">
            <ui-form-text v-model="form.email"/>
          </ui-form-item>
          <ui-form-item label="Пароль" required class="mt-4">
            <ui-form-password v-model="form.password"/>
          </ui-form-item>

          <ui-alert v-show="error" class="mt-4">
            <p class="text-sm text-yellow-800">
              {{ error }}
            </p>
          </ui-alert>

          <div class="mt-6 flex items-center justify-end">
            <div class="text-sm leading-5">
              <router-link to="/restore" class="link">Забыли пароль?</router-link>
            </div>
          </div>

          <div class="mt-6">
            <ui-button type="submit" class="block w-full" :disabled="!formValid">Войти</ui-button>
          </div>
        </ui-form>
      </div>
    </div>
  </div>
</template>

<script>

import {mapActions} from 'vuex'
import UiButton from "@/components/ui/button/UiButton";
import UiFormItem from "@/components/ui/form/UiFormItem";
import UiFormPassword from "@/components/ui/form/UiFormPassword";
import UiFormText from "@/components/ui/form/UiFormText";
import UiAlert from "@/components/ui/alert/UiAlert";
import UiForm from "@/components/ui/form/UiForm";

export default {
  name: "Login",
  components: {UiForm, UiAlert, UiFormText, UiFormPassword, UiFormItem, UiButton},
  data() {
    return {
      form: {
        email: 'merk@live.ru',
        password: 'qweqwe1'
      },
      error: ''
    }
  },
  methods: {
    ...mapActions('account', ['login']),
    tryLogin() {
      this.error = ''

      this.login(this.form).then(() => {
        this.form = {email: '', password: ''}
        this.$router.push({name: 'Home'})
      }).catch(errors => {
        console.log(errors)
        this.error = errors.auth.join(' ');
      })
    }
  },
  computed: {
    formValid() {
      return this.form.email !== '' && this.form.password !== '';
    }
  }
}
</script>